import React from 'react';

import {Cell} from '@pb/kit-component-data-table-v2';

import {mainColumnCell, mainColumnCellLabel} from './main-column-cell.module.styl';

import type {CellOptions} from '@pb/kit-component-data-table-v2';

type Props = {
    children: React.ReactNode,
    selection: React.ReactNode,
    cellOptions: CellOptions,
};

export const MainColumnFreeResourceCell: React.FC<Props> = props => {
    const {
        children,
        selection,
        cellOptions,
    } = props;

    return (
        <Cell{...cellOptions}>
            <div className={mainColumnCell}>
                <div style={{width: 50}}>
                    {selection}
                </div>
                <div className={mainColumnCellLabel}>
                    {children}
                </div>
            </div>
        </Cell>
    );
};
